import { Navigate } from 'react-router-dom'

import { UsuárioAutenticadoContexto } from '@/contextos/UsuárioAutenticado'
import { SplashPágina } from '@/páginas/publicas/Splash'
import { useContextSelector } from 'use-context-selector'

export interface IAuthGuardProps {
  PageElement: () => JSX.Element
  redirectPathSuccess: string
}

export const AutenticaçãoCallback = ({
  PageElement,
  redirectPathSuccess,
}: IAuthGuardProps) => {
  const status = useContextSelector(
    UsuárioAutenticadoContexto,
    (value) => value.status,
  )
  const error = useContextSelector(
    UsuárioAutenticadoContexto,
    (value) => value.error,
  )
  const storage = localStorage.getItem('@Esforce-wellcome')

  const handleError = () => {
    if (storage === null) {
      return <Navigate to={`/wellcome`} />
    }
    if (
      error?.response?.data.error ===
      'Acesso não permitido dentro desse dia e/ou horário'
    ) {
      return <Navigate to={`/bloqueado`} />
    }

    return <Navigate to={`/login`} />
  }

  const renderLoadingPage = () => <SplashPágina />

  switch (status) {
    case 'error':
      return handleError()

    case 'success':
      return <PageElement />

    case 'loading':
    case undefined:
      return renderLoadingPage()

    default:
      return renderLoadingPage()
  }
}
